import SectionList from './Section.view';

export default SectionList;
